import api, { transformRequest, transformResponse } from "services/api";

export const organizationSettingsApi = api
  .enhanceEndpoints({
    addTagTypes: ["Developers"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchDevelopers: build.query({
        query: () => "/api/v1/core/developers/",
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? // successful query
              [
                ...results.map(({ id }) => ({ type: "Developers", id })),
                { type: "Developers", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'Developers', id: 'LIST' }` is invalidated
              [{ type: "Developers", id: "LIST" }],
      }),
      createDeveloper: build.mutation({
        query: (payload) => ({
          url: "/api/v1/core/developers/create/",
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "Developers", id: "LIST" }],
      }),
      updateDeveloper: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/developers/${payload.id}/update/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: (result, error, arg) => [{ type: "Developers", id: arg.id }],
      }),
      deleteDeveloper: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/developers/${payload.id}/delete/`,
          method: "POST",
        }),
        invalidatesTags: [{ type: "Developers", id: "LIST" }],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useFetchDevelopersQuery,
  useCreateDeveloperMutation,
  useUpdateDeveloperMutation,
  useDeleteDeveloperMutation,
} = organizationSettingsApi;
